import React, { useEffect, useState } from 'react';

import callImg from "../../images/call_3_1x.png"

const RedirectToPhone = () => {
  const [phoneNumber, setPhoneNumber] = useState(null);

  // Функция для извлечения номера телефона из URL
  const getPhoneNumberFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const phone = urlParams.get('phone');
    return phone ? phone.trim() : null;
  };

  // Перенаправление на tel: с номером телефона
  const redirectToPhone = (number) => {
    if (number) {
      window.location.href = `tel:+${number}`;
    }
  };

  useEffect(() => {
    const number = getPhoneNumberFromUrl();
    setPhoneNumber(number);
    redirectToPhone(number);
  }, []);

  return (
    <div className='call-container'>
      <p>
        Если номер не набрался автоматически,{' '}
        <a id="phoneLink" href={`tel:+${phoneNumber || ''}`}>
          нажмите здесь
        </a>.
      </p>

      <img src={callImg} alt="" className="img-call"/>

    </div>
  );
};

export default RedirectToPhone;
